var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { format } from "date-fns";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { getObservableT, i18nGetDateFnsLocale } from "../Infra/i18next";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
const t = getObservableT("patients");
export class PatientConsentDeclinedAccessViewModel extends PatientConsentViewModel {
    constructor() {
        super(...arguments);
        this.isCompleting = false;
    }
    get title() {
        return t("You already declined access to your records");
    }
    get supportingText() {
        const date = this.responseDate !== null ? this.formatDate(this.responseDate) : null;
        if (this.isAIFlow) {
            return t("You already responded to this request on {{ date }}. Your health records were not connected with {{ aiToolName }}.", {
                date,
                aiToolName: this.aiToolName,
            });
        }
        if (this.isIAS) {
            return t("You already declined access to your records on {{ date }}. Your health records were not accessed.", {
                date,
            });
        }
        return t("You already responded to this request on {{ date }}. Your health records were not shared with {{ orgName }}.", {
            date,
            orgName: this.organizationName,
        });
    }
    get confirmButtonText() {
        return this.isIAS ? t("I want to access my records") : t("I want to share my records");
    }
    get confirmationAccessSettingsText() {
        return t("You can review and change access settings at any time on HealthEx.");
    }
    get organizationLogoUrl() {
        if (this.patientConsentUIManager.studyInfo !== NOT_LOADED && this.patientConsentUIManager.studyInfo !== null) {
            return this.patientConsentUIManager.studyInfo.organizationIconUrl;
        }
        return null;
    }
    get responseDate() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.patientConsentUIManager.session.consentInfo) === null || _a === void 0 ? void 0 : _a.consentRecord) === null || _b === void 0 ? void 0 : _b.timestamp) !== null && _c !== void 0 ? _c : null;
    }
    formatDate(date) {
        return format(new Date(date), "MM-dd-yyyy", { locale: i18nGetDateFnsLocale() });
    }
    shareRecords() {
        this.patientConsentUIManager.reconsent();
    }
    goToHealthExPortal() {
        this.patientConsentUIManager.close();
    }
    async onComplete() {
        if (this.isPreview)
            return;
        if (this.isCompleting)
            return;
        this.isCompleting = true;
        if (this.isOAuthFlow) {
            await this.patientConsentUIManager.completeOAuthAfterPDDE("declined");
        }
        else if (this.hasHostedRedirectUrl) {
            await this.patientConsentUIManager.handleRedirectForHostedFlow("declined");
        }
        else {
            this.patientConsentUIManager.close();
        }
    }
}
__decorate([
    observable
], PatientConsentDeclinedAccessViewModel.prototype, "isCompleting", void 0);
__decorate([
    computed
], PatientConsentDeclinedAccessViewModel.prototype, "title", null);
__decorate([
    computed
], PatientConsentDeclinedAccessViewModel.prototype, "supportingText", null);
__decorate([
    computed
], PatientConsentDeclinedAccessViewModel.prototype, "confirmButtonText", null);
__decorate([
    computed
], PatientConsentDeclinedAccessViewModel.prototype, "confirmationAccessSettingsText", null);
__decorate([
    computed
], PatientConsentDeclinedAccessViewModel.prototype, "organizationLogoUrl", null);
__decorate([
    computed
], PatientConsentDeclinedAccessViewModel.prototype, "responseDate", null);
